'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobal$002dSpinner from "./presto.-Global-Spinner.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Globals$() {
  this.mX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.a88 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Cx = null;
  this.h9 = null;
  this.JO = null;
  this.kc = null;
  this.Cw = null;
  this.aTv = null;
  $n_Lpresto_Globals$ = this;
  this.mX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(1, 0);
  this.a88 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Cx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_eventbus_EventBus();
  this.h9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this.Cx.br), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction0((() => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$())), false);
  this.JO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lpresto_Globals$().h9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$1) => ((!_$1.k()) && _$1.q().adX($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().Ys)))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
  this.kc = new $j_presto$002e$002dGlobal$002dSpinner.$c_Lpresto_GlobalSpinner($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5(false), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
  this.Cw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5(false);
  this.aTv = "https://oystr.movidesk.com/form/3826/";
}
export { $c_Lpresto_Globals$ as $c_Lpresto_Globals$ };
$p = $c_Lpresto_Globals$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Globals$;
/** @constructor */
function $h_Lpresto_Globals$() {
}
export { $h_Lpresto_Globals$ as $h_Lpresto_Globals$ };
$h_Lpresto_Globals$.prototype = $p;
var $d_Lpresto_Globals$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Globals$, "presto.Globals$", ({
  IO: 1
}));
export { $d_Lpresto_Globals$ as $d_Lpresto_Globals$ };
var $n_Lpresto_Globals$;
function $m_Lpresto_Globals$() {
  if ((!$n_Lpresto_Globals$)) {
    $n_Lpresto_Globals$ = new $c_Lpresto_Globals$();
  }
  return $n_Lpresto_Globals$;
}
export { $m_Lpresto_Globals$ as $m_Lpresto_Globals$ };
//# sourceMappingURL=presto.-Globals$.js.map
